export default function StripeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
